import axios from 'axios';
import config from 'shared/assets/config';

let currentSessionId: string | null = null;
let lastSessionAppId: string | null = null;

export const getSessionId = (): string | null => currentSessionId;

export const setSessionId = (id: string | null): void => {
  currentSessionId = id;
};

export const createSession = async (policyId: string): Promise<string | null> => {
  // Session API not ready in prod - skip for now
  return null;

  if (lastSessionAppId === policyId && currentSessionId) {
    return currentSessionId;
  }
  lastSessionAppId = policyId;

  try {
    const response = await axios.post<{ sessionId: string }>(
      `${config.apiBaseUrl}/api/v2/policyapplications/${policyId}/session`,
      null,
      {
        headers: {
          'Content-Type': 'application/json',
          apiKey: config.apiKey,
        },
      }
    );
    currentSessionId = response.data.sessionId;
    return currentSessionId;
  } catch {
    return null;
  }
};
